/* Court Vibes, 09.10.2026. Hauptmenue, erstes Schweben.

   Houda: beim ersten Schweben ueber "Designs" oeffnet sich das Untermenue
   manchmal nicht, erst beim zweiten Mal.

   Ursache, im Theme nachgelesen: das Menue oeffnet sich ueber das Ereignis
   pointerenter am Menuepunkt, verarbeitet von assets/header-menu.js. Diese
   Datei laedt das Theme mit niedriger Prioritaet nach (fetchpriority low),
   hinter rund 40 anderen Modulen. Liegt die Maus schon auf dem Menuepunkt,
   wenn das Skript endlich fertig ist, kommt kein neues pointerenter mehr.
   Erst wer den Punkt verlaesst und zurueckkommt, sieht das Menue.

   Dieses Skript merkt sich den zuletzt beruehrten Menuepunkt und stoesst
   pointerenter noch einmal an, sobald header-menu definiert ist und die
   Maus noch dort liegt. Das ist derselbe Weg, den das Theme in
   header-menu.js selbst benutzt (reconcilePointerTarget).

   Faellt die Datei aus, bleibt alles wie vorher. Probe im Browser:
   getComputedStyle(document.documentElement).getPropertyValue('--cv-menue') */
(function () {
  if (!('customElements' in window) || typeof PointerEvent !== 'function') return;

  var zuletzt = null;

  document.addEventListener('pointerover', function (e) {
    var ziel = e.target;
    if (!ziel || !ziel.closest) return;
    var li = ziel.closest('.menu-list__list-item');
    if (li) zuletzt = li;
  }, true);

  customElements.whenDefined('header-menu').then(function () {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (!zuletzt || !zuletzt.matches(':hover')) return;
        var link = zuletzt.querySelector('[ref="menuitem"]');
        if (link && link.getAttribute('aria-expanded') === 'true') return;
        zuletzt.dispatchEvent(new PointerEvent('pointerenter', { bubbles: false }));
      });
    });
  });

  document.documentElement.style.setProperty('--cv-menue', 'on');
})();
